import PersonalEmployeeProfile from "@/modules/personal/stores/profile/personal_employee_profile_store";
import PersonalEmployeeImage from "./image/personal_image.store";

export default {
  modules: { PersonalEmployeeProfile, PersonalEmployeeImage },
};
